import axiosInstance from "../config/axios.config";

export const getSessionsAPI = async (admissionID) => {
  const params = admissionID ? { params: { admission_id: admissionID } } : {};
  const res = await axiosInstance.get(`/outpatient/sessions/`, params);

  const raw = Array.isArray(res.data)
    ? res.data
    : res.data?.data || res.data?.results || [];

  const formatted = raw.map((item) => ({
    ...item,
    therapy:
      item.therapy ||
      item.service_id ||
      item.service_name ||
      item.service ||
      item.service_name_id ||
      item.therapy_id,
    done_by:
      item.done_by || item.created_by || item.created_by_id || item.user_id,
    id: item.id,
    duration: item.duration,
    comments: item.comments,
    time_done: item.time_done || item.time || null,
    service_type: item.service_type || item.service_name || item.name,
  }));

  return { ...res, data: formatted };
};

export const updateSessionAPI = (id, data) =>
  axiosInstance.put(`/outpatient/sessions/${id}/`, data);

export const deleteSessionAPI = (id) =>
  axiosInstance.delete(`/outpatient/sessions/${id}/`);

export const getTherapiesAPI = () =>
  axiosInstance.get(`/careservices/therapies/`);

export const getPractitionersAPI = (facilityID, role = "Physiotherapist") =>
  axiosInstance.get(`/accounts/practitioners-list/`, {
    params: { facility: facilityID, role },
  });

export const getServiceTypesAPI = (admissionID) =>
  axiosInstance.get(`/careservices/op-package-progress/${admissionID}/`);

export const createSessionAPI = (data) =>
  axiosInstance.post("/outpatient/sessions/", data);

export const updatePhysioCareAPI = (id, payload) =>
  axiosInstance.patch(`/outpatient/sessions/${id}/`, payload);

export const deletePhysioCareAPI = (id) =>
  axiosInstance.delete(`/outpatient/sessions/${id}/`);

export const getExercisesAPI = (search = "") =>
  axiosInstance.get(`/outpatient/exercises/`, {
    params: search ? { search } : {},
  });
export const addPatientExerciseAPI = (payload) =>
  axiosInstance.post(`/outpatient/patient-exercise/`, payload);

export const uploadExerciseFileAPI = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post(`outpatient/uploads/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const submitTherapyAPI = (data) =>
  axiosInstance.post("/outpatient/therapies/", data);

export const updateTherapyAPI = (id, payload) =>
  axiosInstance.patch(`/outpatient/therapies/${id}/`, payload);

export const deleteTherapyAPI = (id) =>
  axiosInstance.delete(`/outpatient/therapies/${id}/`);

export const getPatientExerciseAPI = (admissionId) => {
  return axiosInstance.get(
    `/outpatient/patient-exercise/?admission_id=${admissionId}`
  );
};

export const submitScaleAPI = (data) =>
  axiosInstance.post("/outpatient/scales/", data);

export const updateScaleAPI = (id, payload) =>
  axiosInstance.patch(`/outpatient/scales/${id}/`, payload);

export const getPatientExercisesAPI = (admissionId) =>
  axiosInstance.get(
    `/outpatient/patient-exercise/?admission_id=${admissionId}`
  );
  export const updatePatientExerciseAPI = (id, payload) => {
  return axiosInstance.patch(`/outpatient/patient-exercise/${id}/`, payload);
};
export const deleteExerciseAPI = (id) => {
  return axiosInstance.delete(`/outpatient/patient-exercise/${id}/`);
};

export const createProgressNoteAPI = (payload) =>
  axiosInstance.post(`/outpatient/progress-notes/`, payload);

export const updateProgressNoteAPI = (id, payload) =>
  axiosInstance.patch(`/outpatient/progress-notes/${id}/`, payload);

export const deleteProgressNoteAPI = (id) =>
  axiosInstance.delete(`/outpatient/progress-notes/${id}/`);

export const getProgressNotesAPI = async (admissionId, params = {}) => {
  const res = await axiosInstance.get(`/outpatient/progress-notes/`, {
    params: { admission_id: admissionId, ...params },
  });

  const responseData = res.data;

  const raw = responseData?.results || [];

  const formatted = raw.map((item) => ({
    ...item,
    id: item.id,
    notes: item.notes,
    done_by: item.done_by,
    done_by_first_name: item.done_by_first_name,
    done_by_last_name: item.done_by_last_name,
    done_by_role: item.done_by_role,
    updated_at: item.updated_at,
  }));

  return {
    ...res,
    data: {
      ...responseData,
      results: formatted,
    },
  };
};

export const fetchSummaryAPI = (emrId, serviceType, token) => {
  return axiosInstance.get(`/outpatient/services/${serviceType}/download/${emrId}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const downloadSummaryAPI = (emrId, serviceType, token) => {
  return axiosInstance.get(`/outpatient/services/${serviceType}/download/${emrId}/`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
};
export const getPackageProgressAPI = (admissionId) => {
  return axiosInstance.get(`/careservices/op-package-progress/${admissionId}/`);
};

export const getPackagesAPI = (facilityId) => {
  return axiosInstance.get(`/careservices/packages/`, {
    params: { facility_id: facilityId ,package_type: "OP" },
  });
};
export const addExerciseAPI = (payload) => axiosInstance.post("/outpatient/exercises/", payload);
export const getExerciseByIdAPI = (id) => axiosInstance.get(`/outpatient/exercises/${id}/`);
export const updateExerciseAPI = (id, payload) => axiosInstance.patch(`/outpatient/exercises/${id}/`, payload);
export const deleteExercisesAPI = (id) => axiosInstance.delete(`/outpatient/exercises/${id}/`);